<template>
  <img 
    @mouseenter="hover = true"
    @mouseleave="hover = false"
    @click="$emit('click')"
    :src="icon">
</template>

<script>
export default {
    props: {
        price_group: Object
    },
    data() {
        return {
            hover: false
        }
    },
    computed: {
        icon() {
            if (!this.price_group.show_for) return '/icons/link-modif.svg';
            if (this.hover) return '/icons/link-modif-remove.svg';

            return '/icons/link-modif-active.svg';
        }
    }
}
</script>

<style>

</style>